export default __webpack_public_path__ + "static/launching-65153e0626e5f96fb78a1af9a46a4a7e.svg";